import { ICardSettings } from "../../interfaces/AppSettings.interface";

export interface IChooseCardStepModel {
    quantity: number;
    value: number;
}

export class ChooseCardStepModel implements IChooseCardStepModel {
    quantity: number;
    value: number;

    constructor() {
        this.quantity = 1;
        this.value = 0;
    }
    
    static isValid(model: IChooseCardStepModel, cardSettings: ICardSettings) {
        if (cardSettings) {
            if (model.quantity < cardSettings.quantityMin || model.quantity > cardSettings.quantityMax) {
                return false;
            }

            if (model.value < cardSettings.valueMin || model.value > cardSettings.valueMax) {
                return false;
            }

            const cardTotal = model.quantity * model.value;
            if (cardTotal <= 0 || cardTotal > cardSettings.totalValueMax) {
                return false;
            }
        } else {
            if (model.quantity <= 0 || model.value <= 0) {
                return false;
            }
        }

        return true;
    }
}